import { render, staticRenderFns } from "./PredictionsFullscreen.vue?vue&type=template&id=0cd3b721&"
import script from "./PredictionsFullscreen.vue?vue&type=script&lang=js&"
export * from "./PredictionsFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./PredictionsFullscreen.vue?vue&type=style&index=0&id=0cd3b721&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports